document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Stagger index for grouped reveals ---------- */
  document.querySelectorAll('.reveal-stagger').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.style.setProperty('--stagger-index', i);
    });
  });

  /* ---------- Count-up stat ---------- */
  var statEls = document.querySelectorAll('[data-count-to]');
  if ('IntersectionObserver' in window && statEls.length) {
    var statIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count-to')) || 0;
        var suffix = el.getAttribute('data-count-suffix') || '';
        var duration = 1400;
        var start = null;

        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        statIO.unobserve(el);
      });
    }, { threshold: 0.5 });
    statEls.forEach(function (el) { statIO.observe(el); });
  }

  /* ---------- Option cards (quantity / bundle selection) ---------- */
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    var cards = group.querySelectorAll('.option-card, .freq-option');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var priceTarget = document.querySelector('[data-price-display]');
        var newPrice = card.getAttribute('data-price');
        if (priceTarget && newPrice) { priceTarget.textContent = newPrice; }
      });
    });
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var stickyAtc = document.querySelector('.sticky-atc');
  var atcTrigger = document.querySelector('[data-atc-trigger]');
  if (stickyAtc && atcTrigger && 'IntersectionObserver' in window) {
    var atcIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    atcIO.observe(atcTrigger);
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (main) { main.src = thumb.getAttribute('data-full-src') || thumb.src; }
    });
  });

  /* ---------- Sticky header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---------- Cart drawer (real AJAX cart) ---------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartBody = document.querySelector('[data-cart-body]');
  var cartSubtotal = document.querySelector('[data-cart-subtotal]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!cartBody) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    } else {
      cartBody.innerHTML = cart.items.map(function (item, i) {
        return '<div class="cart-drawer__item">' +
          '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
          '<div>' +
            '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
            '<p class="cart-drawer__item-variant">' + (item.variant_title || '') + '</p>' +
            '<div class="cart-drawer__item-qty">' +
              '<button data-cart-qty-decrease data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-cart-qty-increase data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<button class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '">Remove</button>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
        '</div>';
      }).join('');
    }
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    var cartCountEl = document.querySelector('[data-cart-count]');
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartDrawer() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCartDrawer();
    }
    if (e.target.closest('[data-cart-close]')) {
      closeCartDrawer();
    }
    if (e.target.closest('[data-cart-remove]')) {
      var key = e.target.closest('[data-cart-remove]').getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
    if (e.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease]')) {
      var btn = e.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease]');
      var key2 = btn.getAttribute('data-key');
      var qty = btn.getAttribute('data-qty');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key2, quantity: Number(qty) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* Handle non-product add-to-cart forms. Product forms remain native for Kaching compatibility. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    /* Product forms are intentionally left native so Kaching and other bundle apps
       can own the add-to-cart event without this theme adding a duplicate item. */
    if (form.hasAttribute('data-product-form')) return;
    e.preventDefault();

    var formData = new FormData(form);
    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Unable to add product');
        return r.json();
      })
      .then(function () {
        if (form.hasAttribute('data-direct-checkout')) {
          window.location.assign('/checkout');
          return;
        }
        if (submitButton) submitButton.disabled = false;
        openCartDrawer();
      })
      .catch(function () {
        if (submitButton) submitButton.disabled = false;
        form.submit();
      });
  });

  /* ---------- Mobile nav toggle ---------- */
  var navToggle = document.querySelector('.site-header__mobile-toggle');
  var navRow = document.querySelector('.site-header__nav-row');
  if (navToggle && navRow) {
    navToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = navRow.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      navToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      navRow.setAttribute('aria-hidden', open ? 'false' : 'true');
    });

    navRow.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        navRow.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        navToggle.setAttribute('aria-label', 'Open menu');
        navRow.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ---------- Sticky mobile Add to Cart ---------- */
  document.querySelectorAll('[data-sticky-buy]').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (button.disabled) return;
      var formId = button.getAttribute('data-product-form-id');
      var form = formId ? document.getElementById(formId) : document.querySelector('form[data-product-form]');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') {
        var mainSubmit = form.querySelector('[type="submit"]');
        form.requestSubmit(mainSubmit || undefined);
      } else {
        var evt = document.createEvent('Event');
        evt.initEvent('submit', true, true);
        if (form.dispatchEvent(evt)) form.submit();
      }
    });
  });
});


/* ===== PÚRI premium interactions ===== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ingredient-carousel]').forEach(function (section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-ingredient-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ingredient-panel]'));
    var visual = section.querySelector('.actives-premium__visual');
    if (!tabs.length) return;
    var index = 0, timer;
    function activate(i) {
      index = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t,n){t.classList.toggle('is-active', n===index);});
      panels.forEach(function (p,n){p.classList.toggle('is-active', n===index);});
      if (visual){visual.classList.add('is-pulsing');setTimeout(function(){visual.classList.remove('is-pulsing');},550);}
      var progress=section.querySelector('.ingredient-progress span');
      if(progress){progress.style.animation='none';void progress.offsetWidth;progress.style.animation='';}
    }
    function restart(){clearInterval(timer);if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(function(){activate(index+1);},3600);}
    tabs.forEach(function(tab,i){tab.addEventListener('click',function(){activate(i);restart();});});
    activate(0);restart();
  });
  document.querySelectorAll('[data-social-reviews]').forEach(function(section){
    var track=section.querySelector('.social-reviews__track'),cards=Array.prototype.slice.call(section.querySelectorAll('.social-review-card')),prev=section.querySelector('[data-social-prev]'),next=section.querySelector('[data-social-next]'),meter=section.querySelector('.social-reviews__meter span');
    if(!track||!cards.length)return;
    function step(dir){var amount=cards[0].getBoundingClientRect().width+20;track.scrollBy({left:dir*amount,behavior:'smooth'});}
    function updateMeter(){var max=Math.max(1,track.scrollWidth-track.clientWidth);var pct=Math.max(14,Math.min(100,14+(track.scrollLeft/max)*86));if(meter)meter.style.width=pct+'%';}
    if(prev)prev.addEventListener('click',function(){step(-1);});if(next)next.addEventListener('click',function(){step(1);});track.addEventListener('scroll',updateMeter,{passive:true});
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){var timer=setInterval(function(){var max=track.scrollWidth-track.clientWidth;if(track.scrollLeft>=max-10)track.scrollTo({left:0,behavior:'smooth'});else step(1);},4200);section.addEventListener('mouseenter',function(){clearInterval(timer);});}
    updateMeter();
  });
});

/* ===== V11 storefront reliability guards ===== */
(function () {
  function syncNavigationState() {
    var nav = document.querySelector('.site-header__nav-row');
    var toggle = document.querySelector('.site-header__mobile-toggle');
    if (!nav) return;
    var mobile = window.matchMedia('(max-width: 900px)').matches;
    if (!mobile) {
      nav.setAttribute('aria-hidden', 'false');
      nav.classList.remove('is-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      }
    } else if (!nav.classList.contains('is-open')) {
      nav.setAttribute('aria-hidden', 'true');
    }
  }
  document.addEventListener('DOMContentLoaded', syncNavigationState);
  window.addEventListener('resize', syncNavigationState, { passive: true });
})();
